import type { ReactNode } from 'react'
import ArrowRight from '../../icons/ArrowRight'
import Accordion from '../Accordion'

type Action = { type: 'chevron'; onClick: () => void } | { type: 'custom'; item: ReactNode } | { type: 'none' }

type TableMobileCardContentProps = {
  header: ReactNode
  data: { label: string; value: React.ReactNode }[]
  action?: Action
}

export function TableMobileCardContent({ header, action, data }: TableMobileCardContentProps) {
  const needsAccordion = data?.length > 3
  const visibleData = needsAccordion ? data.slice(0, 3) : data
  const hiddenData = needsAccordion ? data.slice(3) : []

  return (
    <div className="overflow-hidden">
      <div className="flex items-center justify-between p-3 border-b border-borderGray bg-grayLight">
        <div className="font-bold text-base rounded-t-md">{header}</div>
        {action?.type === 'custom' ? (
          <button type="button" onClick={(e) => e.stopPropagation()}>
            {action.item}
          </button>
        ) : action?.type === 'chevron' ? (
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation()
              action.onClick()
            }}
          >
            <ArrowRight />
          </button>
        ) : null}
      </div>
      <div className="flex flex-col justify-center px-3">
        {visibleData?.map((item, index) => {
          return (
            <div key={index} className="flex flex-row w-full justify-between py-3">
              <div className="text-sm text-secondaryText">{item.label}</div>
              <div className="text-sm text-primaryText text-right font-semibold">{item.value}</div>
            </div>
          )
        })}
        {needsAccordion && (
          <Accordion
            className="text-interaction hover:text-interactionHover"
            position="above"
            label="Se mer informasjon"
            labelClosed="Lukk informasjon"
          >
            {hiddenData.map((item, index) => {
              return (
                <div key={index} className="flex flex-row w-full justify-between py-3">
                  <div className="text-sm text-secondaryText">{item.label}</div>
                  <div className="text-sm text-primaryText text-right font-semibold">{item.value}</div>
                </div>
              )
            })}
          </Accordion>
        )}
      </div>
    </div>
  )
}

export default TableMobileCardContent
